"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentPreview = void 0;
const React = require("react");
class ComponentPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
        };
    }
    componentDidMount() {
        if (this.shouldRenderExample()) {
            const { examples, renderExample } = this.props;
            renderExample(examples[0], this.container).catch((error) => this.setState({ error: error.message }));
        }
    }
    render() {
        const { error } = this.state;
        const { examples } = this.props;
        if (!examples.length) {
            return React.createElement("span", { style: { color: 'grey' } }, "\u26A0\uFE0F Warning: no code examples");
        }
        if (error) {
            return React.createElement("span", { style: { color: 'red' } },
                "\u26D4 Error: ",
                error);
        }
        return (React.createElement("div", { ref: (ref) => {
                this.container = ref;
            } }));
    }
    shouldRenderExample() {
        return !!this.container && !this.state.error && this.props.examples.length > 0;
    }
}
exports.ComponentPreview = ComponentPreview;
//# sourceMappingURL=ComponentPreview.js.map